import React, { useState } from 'react';
import { BodyText, Div, GridBag, Gutter, Headline, Icon, Image } from '@gaiads/telia-react-component-library';
import { useToBreakpoint } from '@cdaas/reusable-components-daas';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { AllowanceType, UserRole } from '@cdaas/api-clients/dist/asset-user-openapi';
import { RootState } from '../../store/reducers';
import { checkIsSelectedOrganizationOwn, hasUserARequiredRole, isNumeric, isSingleDevicePolicyInEffectForUser } from '../../utils';
import Allowance from './Allowance/Allowance';
import DeviceLimitFullNotification from '../../Components/Notification/DeviceLimitFullNotification';

import heroImage from '../../assets/images/products_bundles_listing_hero_image.png';
import './Home.css';

export const Home = () => {
  const history = useHistory();
  const authenticatedUser = useSelector((state: RootState) => state.authentication.user);
  const selectedOrganization = useSelector((state: RootState) => state.authentication.selectedOrganization);
  const ordersToApprove = useSelector((state: RootState) => state.authentication.pendingApprovals);
  const isMobile = useToBreakpoint(840);
  const { t } = useTranslation('product');

  const [deviceLimitFullInfoDismissed, setDeviceLimitFullInfoDismissed] = useState(false);

  const givenNameInUpperCase = authenticatedUser?.given_name?.toUpperCase() ?? '';
  const greetingTextInUpperCase = t('ProductListingComponent.greeting').toUpperCase();

  const isSelectedOrganizationOwn = checkIsSelectedOrganizationOwn(authenticatedUser?.organization?.id, selectedOrganization?.id);
  const showOwnAllowance =
    isSelectedOrganizationOwn &&
    (authenticatedUser?.allowance_type === AllowanceType.Monthly || authenticatedUser?.allowance_type === AllowanceType.OneTime) &&
    isNumeric(authenticatedUser.allowance);

  const GreetingHeadlines = isMobile ? (
    <Headline size="xlg" color="black" tagName="h1">
      {greetingTextInUpperCase} {givenNameInUpperCase}
    </Headline>
  ) : (
    <>
      <Headline size="xlg" color="black" tagName="h1">
        {greetingTextInUpperCase}
      </Headline>
      <Headline size="xlg" color="black" tagName="h1">
        {givenNameInUpperCase}
      </Headline>
    </>
  );

  return (
    <>
      <GridBag>
        <GridBag.Item sm={12} md={6}>
          <Gutter size={isMobile ? 'xlg' : 'layout-8'} />
          {GreetingHeadlines}
          {hasUserARequiredRole([UserRole.Approver]) && !!ordersToApprove ? (
            <>
              <BodyText margin={{ top: 'md' }} color="gray500" fontWeight="bold">
                {t('ProductListingComponent.pendingApprovals', { amount: ordersToApprove })}
              </BodyText>
              <BodyText margin={{ top: 'md' }} color="purple500" clickableAppearance fontWeight="medium" onClick={() => history.push('/approval')}>
                {t('ProductListingComponent.approvalsLink')}
                <Icon tagName="span" name="chevron-right" size="sm" padding={{ top: 'xxxs' }} />
              </BodyText>
            </>
          ) : (
            <BodyText color="gray500" fontWeight="bold" padding={{ top: 'md' }} style={{ maxWidth: '448px' }}>
              {t('ProductListingComponent.heroDescription')}
            </BodyText>
          )}
        </GridBag.Item>
        <GridBag.Item sm={12} md={6}>
          {showOwnAllowance && <Gutter size={isMobile ? 'xlg' : 'layout-8'} />}
          {showOwnAllowance && <Allowance user={authenticatedUser} />}
          <Image className={'mobile-phone-image'} src={heroImage} alt="Mobile phone" />
        </GridBag.Item>
      </GridBag>
      {!deviceLimitFullInfoDismissed && isSingleDevicePolicyInEffectForUser('authenticated') && (
        <Div>
          <Gutter size="md" />
          <DeviceLimitFullNotification closeOnClick={() => setDeviceLimitFullInfoDismissed(true)} />
          <Gutter size="lg" />
        </Div>
      )}
    </>
  );
};

export default Home;
